/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-16 20:41:05
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-06-16 21:59:27
 */
export const routerFor = (list, key) => {
    const arr = [];
    list.map((item, index) => {
        let isTrue = false;
        if (item.privilegeVoList) {
            item.privilegeVoList.map((vo) => {
                if (vo.privilegeCode == "100501" && vo.checked) {
                    isTrue = true;
                }
            });
        }
        if (!item.privilegeVoList) {
            isTrue = true;
        }
        if (key) {
            item.menuIndex = key + "-" + index;
        }
        else {
            item.menuIndex = index + "";
        }
        if (item.children) {
            item.children = routerFor(item.children, item.menuIndex);
        }
        if (isTrue) {
            arr.push(item);
        }
    });
    return arr;
};
